import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, ControlLabel, HelpBlock, FormControl, InputGroup } from 'react-bootstrap';
import MuiSlider from '@material-ui/core/Slider';
import MuiTooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

const Slider = ({ horizontal, required, input, labelCol = 3, valueCol = 9, label, help, meta: { touched, error, warning }, ...props }) => {
	const validationState = touched && (error && "error") || (warning && "warning") || null;

	const formControl = <MuiSlider ValueLabelComponent={ValueLabelComponent} onChange={(event, value) => input.onChange(value)} value={input.value} name={input.name} {...props} />;
	const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
	const labelHint = required && <em style={{ color: '#D62229' }}>*</em>;

	if (horizontal) {
		return (
			<FormGroup validationState={validationState} className='row'>
				<Col componentClass={ControlLabel} sm={labelCol}>
					{label}{labelHint}
				</Col>
				<Col sm={valueCol}>
					{formControl}
					{errorBlock}
					{helpBlock}
				</Col>
			</FormGroup>);
	}

	return (
		<FormGroup validationState={validationState}>
			<ControlLabel>{label}{labelHint}</ControlLabel>
			{formControl}
			{errorBlock}
			{helpBlock}
		</FormGroup>
	);
};

const ValueLabelComponent = ({ children, open, value }) => {
	const classes = tooltipStyle;
	return (
		<StyledTooltip className={classes.tooltip} arrow open={open} enterTouchDelay={0} placement='top' title={value}>
			{children}
		</StyledTooltip>
	);
};

const tooltipStyle = {
	popper: {
		zIndex: 1020
	},
	tooltip: {
		backgroundColor: '#3f51b5',
		color: 'white',
		fontFamily: 'Comfortaa',
		fontSize: '0.7em'
	},
	tooltipPlacementTop: {
		margin: '5px 0'
	},
	arrow: {
		color: '#3f51b5'
	}
};
const StyledTooltip = withStyles(tooltipStyle)(MuiTooltip);

Slider.propTypes = {
	horizontal: PropTypes.bool,
	input: PropTypes.object,
	label: PropTypes.string,
	help: PropTypes.string,
	meta: PropTypes.object,
	disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	min: PropTypes.number,
	max: PropTypes.number,
	step: PropTypes.number,
	marks: PropTypes.oneOfType([PropTypes.array, PropTypes.bool])
};

const sliderStyle = {
	root: { marginTop: 5 },
	markLabel: {
		fontFamily: 'Comfortaa',
		fontSize: '0.8em'
	}
};

export default withStyles(sliderStyle)(Slider);